import { Alert, AlertProps, AlertTitle, SxProps, Theme } from '@mui/material';
import React, { FunctionComponent } from 'react';

const themedSxMap: Record<NonNullable<AlertProps['severity']>, SxProps<Theme>> = {
  warning: {
    backgroundColor: 'maple.lightest',
    border: 1,
    borderColor: 'maple.main',
    color: 'text.primary',
    '& .MuiAlert-icon': {
      color: 'maple.dark',
    },
  },
  error: {
    backgroundColor: 'error.light',
    color: 'text.primary',
    '& .MuiAlert-icon': {
      color: 'error.dark',
    },
  },
  info: {
    backgroundColor: 'info.light',
    color: 'text.primary',
    '& .MuiAlert-icon': {
      color: 'info.dark',
    },
  },
  success: {
    backgroundColor: 'success.light',
    color: 'text.primary',
    '& .MuiAlert-icon': {
      color: 'success.dark',
    },
  },
};

type MoAlertProps = AlertProps & {
  themed?: boolean;
  title?: string;
};

export const MoAlert: FunctionComponent<MoAlertProps> = ({
  themed,
  title,
  sx,
  children,
  ...props
}) => {
  const themedSx =
    themed && props.severity
      ? { alignItems: 'center', ...(themedSxMap[props.severity] as object) }
      : undefined;

  return (
    <Alert sx={[themedSx, sx].filter(Boolean) as SxProps<Theme>} {...props}>
      {title && <AlertTitle sx={{ fontWeight: 700 }}>{title}</AlertTitle>}
      {children}
    </Alert>
  );
};
